import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2LightbulbOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="M13 28h5v2h-5zm-2-1h9v-2h-9zm4.5-25C10.262 2 6 6.262 6 11.5c0 7 5 6.03 5 11.494v1h7.604L20 22l-7.046-.006C12.42 16.453 8 17.22 8 11.5 8 7.364 11.364 4 15.5 4S23 7.364 23 11.5c0 4.876-3.148 4.913-4.497 8.5h2.195C22.016 17.703 25 16.736 25 11.5S20.738 2 15.5 2" /></svg>
);
